import { FormComboBox } from '@/components/forms/form-combo-box';
import { FormInputField } from '@/components/forms/form-input-field';
import { comboBoxOptionsOf } from '@/components/ui/multi-select-utils';
import { getTimezoneTypeahead } from '@/lib/time-zones';
import { CreateUserCommonFormSchema } from '@/routes/_layout/users/-components/form-schema';
import { Role } from '@airreading/common/data';
import { UseFormReturn } from 'react-hook-form';

export function CreateUserCommonForm<T extends object>({
  form: rawForm,
  disabled,
  role,
}: {
  form: UseFormReturn<CreateUserCommonFormSchema & T>;
  disabled?: boolean;
  role?: Role;
}) {
  const form = rawForm as unknown as UseFormReturn<CreateUserCommonFormSchema>;
  const isStudentRole = role === Role.student;
  return (
    <>
      <FormInputField
        name="firstName"
        label="First Name"
        form={form}
        inputProps={{ required: true, className: 'w-[80%]', disabled }}
      />
      <FormInputField
        name="lastName"
        label="Last Name"
        form={form}
        inputProps={{ required: !isStudentRole, className: 'w-[80%]', disabled }}
      />
      <FormInputField
        name="email"
        label="Email"
        form={form}
        inputProps={{ required: true, className: 'w-[80%]', type: 'email', disabled }}
      />
      {!isStudentRole && (
        <>
          <FormInputField
            name="phone"
            label="Phone"
            form={form}
            className=""
            inputProps={{ className: 'w-[80%]', type: 'tel', disabled }}
          />
          <FormComboBox
            name="timeZone"
            label="Time zone"
            form={form}
            {...comboBoxOptionsOf(getTimezoneTypeahead)}
            triggerProps={{ className: 'w-[80%]', disabled }}
          />
          <FormInputField
            name="edlinkId"
            label="Edlink ID"
            form={form}
            className=""
            inputProps={{ className: 'w-[80%] font-mono', type: 'text', disabled }}
          />
        </>
      )}
    </>
  );
}
